import ImagesPallet from "../../../../../../../../utils/ImagesPallet";

const OurStylistArizonaData = [
 {
  name: "Joko",
  image: ImagesPallet.JokoKnoArizona,
  specialty: "Capster",
  experience: "5 years"
 },
 {
  name: "Dicki",
  image: ImagesPallet.DickyKnoArizona,
  specialty: "Hair Stylish",
  experience: "8 years"
 },
 {
  name: "Adi",
  image: ImagesPallet.AdiKnoArizona,
  specialty: "Hair Stylish",
  experience: "8 years"
 },
];

export default OurStylistArizonaData

